import { Component } from 'react';
import ReactDOM from 'react-dom';
import { Footer, SafeAreaWrap, BaseChoose } from '@beisen/chaos-ui';
import BSButton from './Button';
import buttonHandlerMap from './handlerMap';
import { unvisibleButton } from '../util/unvisibleButton';
import * as html from '../util/html';
require('./button.scss');
import * as helper from '../util/helper';
import transLoader from '@beisen/i18n-translation-loader';
const defaultTranslation = {
  more: '更多',
  cancel: '取消',
  listEmpty: '暂时没有信息哦～'
};
const bgColors = ['m-bgcolor-f1', 'm-bgcolor-f2', 'm-bgcolor-f3', 'm-bgcolor-f4', 'm-bgcolor-f5', 'm-bgcolor-f6', 'm-bgcolor-f7', 'm-bgcolor-f8', 'm-bgcolor-f9'];

export default class ButtonList extends Component {
  constructor(props) {
    super(props);
    this.onTouchTap = this.onTouchTap.bind(this);
    this.closePanel = this.closePanel.bind(this);
    this.touchCancle = this.touchCancle.bind(this);
    this.state = {
      footerClass: 'page-footer border-1px'
    };
    this.registedEvent = false;
    this.translation = Object.assign({}, defaultTranslation, transLoader({
      more: 'common.more',
      cancel: 'common.cancel',
      listEmpty: 'common.listEmpty'
    }), props.translation);
  }

  hasButton() {
    return this.refs.buttonList;
  }

  registEvent() {
    if (!this.props.registEvent) return;
    this.props.registEvent(ReactDOM.findDOMNode(this.refs.buttonList));
    this.registedEvent = true;
  }

  removeEvent() {
    this.props.removeEvent && this.props.removeEvent(ReactDOM.findDOMNode(this.refs.buttonList));
  }

  componentDidMount() {
    if (!this.hasButton()) return;
    this.registEvent();
  }

  componentDidUpdate() {
    if (!this.hasButton() || this.registedEvent) return;
    this.registEvent();
  }

  componentWillUnmount() {
    this.hasButton() && this.removeEvent();
  }

  closePanel(e) {
    this.setState({
      dropItems: undefined
    });
  }

  onTouchTap(btnItem) {
    document.body.classList.remove('modal_active');
    let {
      cmpContext,
      data,
      afterAction,
      queryUrl,
      actions,
      pageType,
      pageCode,
      pageName,
      searchCriteria,
      tabelListPostParam
    } = this.props;

    if (btnItem.cmp_id) {
      if (this[btnItem.cmp_id]) {
        return false;
      }
      // 设置再次响应的1s延迟，当连续点击时不会重复发请求等
      this[btnItem.cmp_id] = setTimeout(() => {
        this[btnItem.cmp_id] = null;
      }, 1000);
    }

    if (btnItem.sub_cmps && btnItem.sub_cmps.length > 0) {
      this.setState({
        dropItems: btnItem.sub_cmps
      });
    } else {
      let {
        cmp_data,
        cmp_type
      } = btnItem;
      if (!buttonHandlerMap[cmp_data.action]) {
        console.warn('系统未定义 action');
      }

      if (cmp_type != 'ButtonItem' && cmp_type != 'Button') {
        console.warn('Button 的cmp_type 应为 ButtonItem');
      }
      let datatop = this.props.getScrollTop();
      let buttonData = Object.assign({}, btnItem, {
        cmpContext,
        data,
        afterAction,
        queryUrl,
        pageType,
        pageCode,
        pageName,
        datatop: datatop,
        searchCriteria,
        tabelListPostParam
      });
      if (cmp_data.action == 'PopViewButton') {
        actions.customBtnStartFn(buttonData);
      } else {
        if (!this.props.beforeStartValidte || this.props.beforeStartValidte && this.props.beforeStartValidte(btnItem)) {
          actions.btnStartFn(buttonData);
        }
      }
      this.closePanel();
    }
  }

  componentWillMount() {
    //手机自带的返回按钮，返回时遮罩层不隐藏
    this.props.actions.btnClearFn();
  }

  touchCancle() {
    this.closePanel();
  }

  render() {
    const { partId = '' } = helper.getQueryObject();
    let { sub_cmps, searchCriteria, tabelListPostParam, wrapFooterCls } = this.props, btnlist = [], btnChildren, btnGroup = null;
    let { dropItems } = this.state;
    if (!sub_cmps) return null;
    for (let i = 0; i < sub_cmps.length; i++) {
      let item = sub_cmps[i];
      if (unvisibleButton(item.cmp_data.action)) {
        sub_cmps.splice(i, 1);
        i--;
      } else {
        btnlist.push(<BSButton { ...item }
          key={i}
          btnIdx={i}
          partId={partId || this.props.partId}  //相关对象ID
          buttonId={item.buttonId || item.cmp_id} //按钮id
          searchCriteria={searchCriteria}
          tabelListPostParam={tabelListPostParam}
          onTouchTap={this.onTouchTap}
          bgColors={bgColors[i]} />
        );
      }
    }

    if (sub_cmps.length <= 5) {
      btnChildren = btnlist;
    } else {
      btnChildren = btnlist.slice(0, 4);
      let btnMore = {
        cmp_id: 'ButtonGroupMore-1',
        cmp_name: '',
        'cmp_type': 'ButtonGroup',
        'cmp_data': {
          'title': this.translation.more,
          'display': 'icon-text',
          'icon': 'sys-icon-m-more'
        },
        sub_cmps: sub_cmps.slice(4)
      };
      btnChildren.push(
        <BSButton { ...btnMore }
          searchCriteria={searchCriteria}
          tabelListPostParam={tabelListPostParam}
          onTouchTap={this.onTouchTap}
          bgColors={bgColors[4]}
        />
      );
    }
    if (dropItems) {
      const useableButtonFilter = item => item.cmp_data.visible && !item.cmp_data.disable && !unvisibleButton(item.cmp_data.action);
      const chooseListData = dropItems.filter(useableButtonFilter).map(item => {
        return { title: html.decode(item.cmp_data.title), dataObj: item, buttonId: item.cmp_id };
      });

      const { partId = '' } = helper.getQueryObject();
      btnGroup = (<BaseChoose className={'chooseList'}
        isShowChoose={true}
        animation="bottom-slide-fade"
        maskAnimation="fade"
        title={this.title}
        onPanelClose={this.touchCancle}
        chooseList={chooseListData.reverse()}
        onTouchTap={this.onTouchTap}
        partId={partId || this.props.partId}
        translation={this.translation}
      />);

    }

    return (
      btnChildren.length != 0 ? <SafeAreaWrap ref="buttonList" safeAreaStyle={{ background: '#fff' }} wrapStyle={{ flexShrink: 0 }} wrapCls={wrapFooterCls}>
        <Footer cls='page-footer border-1px' style={this.props.buttonstyle}>
          {btnChildren}
          {btnGroup}
        </Footer>
      </SafeAreaWrap> : null
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/ButtonList.js